var dropdownSubContentScrollAreaViewport = 'fx_2d2fb1e5_xn04g20';

export { dropdownSubContentScrollAreaViewport };
//# sourceMappingURL=subContent.vanilla.mjs.map
